// Validate .stp file
export const validateStpFile = (file: File): { valid: boolean; error?: string } => {
  // Check extension
  if (!file.name.toLowerCase().endsWith('.stp')) {
    return { valid: false, error: 'File must be .stp format' };
  }

  // Check size (max 50MB)
  const maxSize = 50 * 1024 * 1024;
  if (file.size > maxSize) {
    return { valid: false, error: 'File size must be less than 50MB' };
  }

  return { valid: true };
};

// Sanitize filename for use as project title
export const sanitizeFileName = (filename: string): string => {
  return filename.replace(/\.stp$/i, '').replace(/[^a-zA-Z0-9-_ ]/g, '');
};
